import React from 'react'
import { IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

interface DeleteIconButtonProps {
  isDisabled: boolean
  onClick: any
}

export const DeleteIconButton: React.FC<DeleteIconButtonProps> = ({
  isDisabled,
  onClick
}) => {
  return (
    <IconButton
      aria-label='delete'
      disabled={isDisabled}
      onClick={onClick}
      sx={{
        '&:hover, &.Mui-focusVisible': { color: '#f64541' }
      }}
    >
      <DeleteIcon />
    </IconButton>
  )
}
